// removed by extract-text-webpack-plugin
module.exports = {"Title":"styles__Title___3hi4-","Close":"styles__Close___3kVXi","Content":"styles__Content___JM1a1","Footer":"styles__Footer___3R8Xc","ModalContent":"styles__ModalContent___DKc-R","fadein":"styles__fadein___3fZbd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/styles.scss
// module id = 1366
// module chunks = 0